NtechApp.JoinTeamForm = function() {
    var me = this;

    this._ajax = null;
    this._click = null;

    this._form = null;
    this._formDataParser = null;

    this._$searchInput = null;
    this._$searchSublabel = null;
    this._$searchHidden = null;

    // @todo -> Test for multiple autocomplete binds(On form reloads)
    this._searchAuto = null;
    this._submitLoader = null;

    this._construct = function() {
        me._ajax = new NtechApp.Ajax();
        me._click = new NtechApp.TouchClickEvent();
        me._formDataParser = new NtechApp.FormDataParser();

        me._bindEvents();
    }

    this._bindEvents = function() {
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.JoinTeamForm.EVENT_REQUEST_SENT = "NtechApp.JoinTeamForm.EventRequestSent";
NtechApp.JoinTeamForm.EVENT_REQUEST_CANCELED = "NtechApp.JointTeamForm.EventRequestCanceled";

NtechApp.proto(NtechApp.JoinTeamForm, {
    loadForm: function() {
        var me = this;

        me._form = new NtechApp.ModalForm();
        me._form.load('personal_dashboard_load_join_team_form', {}, function($form) {
            me._bindFormEvents.call(me, $form);
        });
    },

    _bindFormEvents: function($form) {
        var me = this;

        me._click.listen($form.find(".formHeader .close .button"), function(event) {
            me._unloadForm();
        });

        $form.find("#join_team_pinCode").on("input", function() {
            var val = $(this).val();
            if(val.length > 4) {
                val = val.slice(0, 4);
                $(this).val(val);
            }
        });

        me._submitLoader = new NtechApp.Loader(18, 18, "absolute", $form.find("[data-formSubmit]"));
        me._submitLoader.getView().css({
            background: '#37bdb1',
            borderRadius: '9px'
        });

        me._$searchInput = $form.find("[data-autocompleteid='targetAccount']");
        me._$searchSublabel = $form.find("[data-autocompleteSublabelId='targetAccount']");
        me._$searchHidden = $form.find("[data-autocompleteHiddenId='targetAccount']");

        me._searchAuto = new NtechApp.Autocomplete(
            me._$searchInput,
            NtechApp.merge(
                NtechApp.autocompleteSettings.default,
                {
                    matchType: NtechApp.Autocomplete.MATCH_TYPES.FULL,
                    getWidth: function ($input) { return $input.outerWidth() - 30; }
                }
            ),
            function() {
                var args = Array.prototype.slice.call(arguments);
                // Push page
                if(arguments.length == 3)
                    args.push(false);

                args.push($form);
                me._loadSearchOpponentResults.apply(me, args);
            }
        );
        me._searchAuto.setModalCss();
        me._bindSearchAutoEvents($form);

        me._click.listen($form, "[data-formSubmit]", function(e) {
            if($(e.target).closest(".formControl").find(".ntechapp-loader").hasClass("visible"))
                return;

            me._saveJoinTeamForm($form);
        });

        me._click.listen($form, ".formErrors", function() {
            $form.find(".formErrors").css("display", "none");
        });
    },

    _unloadForm: function() {
        var me = this;

        me._searchAuto.destroy();
        me._form.unload();
    },

    _enableLoader: function() {
        this._submitLoader.on().white();
    },

    _disableLoader: function() {
        this._submitLoader.off();
    },

    _bindSearchAutoEvents: function($form) {
        var me = this;

        $(me._searchAuto).on(NtechApp.Autocomplete.SELECT_EVENT, function(event, id, name) {
            me._$searchSublabel.text(name);
            me._$searchHidden.val(id);
        });

        me._click.listen(me._searchAuto.getView(), "[data-loadNextSearchResults]", function(event) {
            if($(event.target).hasClass("lockLoadNextButton"))
                return;

            var $loadNext = $(event.target).addClass("selectedItem lockLoadNextButton");
            var page = $loadNext.attr("data-loadNextSearchResults");

            me._ajax.enableTextLoading($loadNext);
            me._loadSearchOpponentResults(
                me._searchAuto.getSearchVal(),
                NtechApp.bind("appendData", me._searchAuto),
                NtechApp.noop,
                page,
                $form
            );
        });

        me._click.listen($form, "[data-accountId]", function(e) {
            var $item = $(e.target).closest("[data-accountId]");
            $item.remove();
        });
    },

    _loadSearchOpponentResults: function(searchVal, onFoundData, onNotFoundData, page, $form) {
        var me = this;

        var params = {
            searchText: searchVal,
            searchPage: page || 0,
            searchType: 1,
            searchResultsType: 1
        };

        me._ajax.get({
            url: Routing.generate('personal_account_search', params),
            onSuccess: function(data) {
                if(data.hasResults)
                    onFoundData(data.html);
                else
                    onNotFoundData(data.html);
            }
        });
    },

    _showErrors: function($form, errors) {
        var me = this;
        var $errors = $form.find(".formErrors");

        $errors.css("display", "block");
        $errors.find(".errorBody > p").remove();

        for(var errorName in errors)
            $errors.find(".errorBody").append("<p>" + errors[errorName] + "</p>");
    },

    _saveJoinTeamForm: function($form) {
        var me = this;
        me._enableLoader();

        var formData = this._formDataParser.getFormJSON($form.find("form"));

        var params = {
            formData: formData
        };

        me._ajax.post({
            url: Routing.generate('personal_dashboard_save_join_team_form'),
            data: params,
            onSuccess: function(data) {
                $(me).trigger(NtechApp.JoinTeamForm.EVENT_REQUEST_SENT, [data.ownerAccountFullname, data.teamMemberId]);
                me._unloadForm();
            },
            onError: function(errors) {
                me._disableLoader();
                me._showErrors($form, errors);
            }
        });
    },

    cancelJoinTeamRequest: function(teamMemberId) {
        var me = this;

        NtechApp.confirmForm.load(function() {
            var params = {
                teamMemberId: teamMemberId
            };

            me._ajax.post({
                url: Routing.generate('personal_dashboard_cancel_join_team_request'),
                data: params,
                onSuccess: function(data) {
                    $(me).trigger(NtechApp.JoinTeamForm.EVENT_REQUEST_CANCELED);
                    NtechApp.confirmForm.unload();
                },
                onError: function(data) {
                    var errText = "";
                    for(var errName in data) 
                        errText += data[errName];

                    NtechApp.confirmForm.unload();
                    NtechApp.info.on(errText, 2500);
                }
            });
        });
    }
});